export enum AgentStatus {
  ACTIVE = "publish",
  INACTIVE = "unpublish",
}

export type AgentInputModel = {
  companyPhone: string,
  companyName: string,
  website: string | null,
  companyEmail: string | null,
  country: string,
  city: string,
  street: string,
  contactName: string,
  contactEmail: string,
  contactPhone: string,
  jobTitle: string | null,
  description: string | null,
  status: AgentStatus
}

export type AgentOutputModel = {
  id: string,
  code: string,
  companyPhone: string,
  companyName: string,
  website: string | null,
  companyEmail: string | null,
  country: string,
  city: string,
  street: string,
  contactName: string,
  contactEmail: string,
  contactPhone: string,
  jobTitle: string | null,
  description: string | null,
  status: AgentStatus
};